// Wrap axios
import axios from 'axios';
import { isPublicPage } from './utilityFunctions';
import { PATHS } from './PagePaths';
import { config } from './config';

const LOCAL_ENV = "https://localhost:8880";
//const ENV = "https://10.101.3.22:8880";
const HTTPS = "https://";
const PORT = ":8880";

// Instance
// Config the baseURL based on the env
const httpDownload = axios.create({
  //baseURL: ENV,
  baseURL: config.baseUrl,
  /***!!! local only */
  //baseURL: HTTPS + window.location.hostname + PORT,
  timeout: 30000
});

// request interceptor: inject token
httpDownload.interceptors.request.use((config) => {

  //token is empty and private page
  if (config.headers["Authorization"] == "Bearer " && isPublicPage(window.location) == false) {//&& !window.location.href.includes("publicpages")) {
    // "" is a public page
    if (window.location.pathname !== '') {
      window.location.href = PATHS.public['Sign In']
      return;
    }
  }

  // check if a new token is generated
  if (localStorage.getItem("token")) {
    config.headers["Authorization"] = "Bearer " + localStorage.getItem("token");
    //console.log("change config header token", config.headers["Authorization"], config);
  }

  return config;
}, (error) => {
  return Promise.reject(error)
});

// Response interceptor
httpDownload.interceptors.response.use((response) => {

  // check if a new token is generated
  if (response.headers["authorization"]) {
    localStorage.setItem("token", response.headers["authorization"]);
  }

  return response;
}, (error) => {

  console.dir(error);

  return Promise.reject(error)
})

export { httpDownload }